
const defaultState = function () {
  return {
    mode: 0,
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      keyword: {
        display: false,
        isAttribute: false,
        required: false,
        title: 'キーワード',
        type: 'Input',
        value: '',
        valueType: null
      },
      siteCodes: {
        type: 'MultiSelector',
        title: 'サイト',
        property: 'siteCode',
        display: false,
        value: [],
        options: []
      },
      stockTypes: {
        type: 'MultiSelector',
        title: '在庫種別',
        property: '',
        display: false,
        value: '',
        options: []
      },
      withEmpty: {
        type: 'MultiSelector',
        title: '在庫有無',
        property: '',
        display: false,
        value: '',
        options: []
      },
      perpetual: {
        type: 'MultiSelector',
        title: '無制限在庫',
        property: '',
        display: false,
        value: '',
        options: []
      },
      artistCode: {
        type: 'Input',
        title: 'アーティストコード',
        property: '',
        display: false,
        value: '',
        options: []
      },
      artistName: {
        type: 'Input',
        title: 'アーティスト名',
        property: '',
        display: false,
        value: '',
        options: []
      },
      productIds: {
        type: 'Input',
        title: 'SKUコード',
        property: '',
        display: false,
        value: '',
        options: []
      },
      productName: {
        type: 'Input',
        title: '商品名(SKU)',
        property: '',
        display: false,
        value: '',
        options: []
      },
      productCategories: {
        type: 'MultiSelector',
        title: '商品区分',
        property: '',
        display: false,
        value: '',
        options: []
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    update (state, data) {
      state.tdLists = state.tdLists.map(t => {
        return t.node.site.code === data.node.site.code &&
                t.node.sku.code === data.node.sku.code &&
                t.node.stockType === data.node.stockType ? data : t
      })
    }
  },
  getDefaultState: defaultState
}
